import { Paper } from '@mui/material';
import { useIsDesktop } from 'Hooks';

export const FormPaper: React.FC<{}> = ({ children }) => {
  const isDesktop = useIsDesktop();

  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        boxShadow: '0px 3px 21px 0px #2D70D926',
        backdropFilter: 'blur(16px)',
        p: isDesktop ? undefined : '0 16px 16px 16px',
      }}
    >
      {children}
    </Paper>
  );
};
